import superagent from 'superagent'

const wind = {
  // `pastHours` prepends that many observed hours (entries with `observed: true`) before the forecast.
  fetchHourly: (props) => {
    const { lat, lng, token, pastHours, hours = 24 } = props
    return new Promise((resolve, reject) => {
      superagent
        .get(`${__API_URI__}/Wind/GetHourly/?latitude=${lat}&longitude=${lng}&hours=${hours}${pastHours ? `&pastHours=${pastHours}` : ''}`)
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err)
          }
          resolve(res.body)
        })
    })
  },
  fetchDaily: (props) => {
    const { lat, lng, token } = props
    return new Promise((resolve, reject) => {
      superagent
        .get(`${__API_URI__}/Wind/GetDaily/?latitude=${lat}&longitude=${lng}`)
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err)
          }
          resolve(res.body)
        })
    })
  }
}

export default wind